import PropTypes from "prop-types"
import Chip from "@mui/material/Chip"
import MDBox from "components/MDBox"
import DataTable from "monitor/Tables/DataTable"

function ReportesInformation({ registros }) {
  const formatTime = (time) => {
    if (!time) return "-"
    return time
  }

  const formatDate = (date) => {
    if (!date) return "-"
    const [year, month, day] = date.split("-")
    return `${day}/${month}/${year}`
  }

  const getEstadoColor = (estado) => {
    switch (estado) {
      case "PRESENTE":
        return "success"
      case "AUSENTE":
        return "error"
      case "LLEGADA_TARDIA":
        return "warning"
      case "SALIDA_TEMPRANA":
        return "info"
      case "LLEGADA_TARDIA_SALIDA_TEMPRANA":
        return "warning"
      default:
        return "default"
    }
  }

  const getEstadoLabel = (estado) => {
    if (!estado) return "SIN ESTADO"
    return estado.replace(/_/g, " ")
  }

  const columns = [
    { Header: "Nombre", accessor: "nombre", width: "20%" },
    { Header: "Tipo", accessor: "tipo", width: "12%" },
    { Header: "Dependencia", accessor: "organizacion", width: "18%" },
    { Header: "Fecha", accessor: "fecha", width: "10%" },
    { Header: "Entrada", accessor: "entrada", width: "8%" },
    { Header: "Salida", accessor: "salida", width: "8%" },
    { Header: "Duración", accessor: "duracion", width: "8%" },
    { Header: "Estado", accessor: "estado", align: "center", width: "10%" },
  ]

  const rows = registros?.map((registro) => ({
    nombre: (
      <MDBox display="flex" alignItems="center" gap={1}>
        {registro.asistenteNombre}
        {registro.registroManual && (
          <Chip
            label="MANUAL"
            color="info"
            size="small"
            variant="outlined"
          />
        )}
      </MDBox>
    ),
    tipo: registro.tipoAsistenteNombre || "-",
    organizacion: registro.dependenciaNombre || "-",
    fecha: formatDate(registro.fecha),
    entrada: formatTime(registro.horaEntrada),
    salida: formatTime(registro.horaSalida),
    duracion: registro.duracion || "-",
    estado: (
      <Chip
        label={getEstadoLabel(registro.estadoAsistencia)}
        color={getEstadoColor(registro.estadoAsistencia)}
        size="small"
      />
    ),
  })) || []

  return (
    <DataTable
      isSorted={false}
      noEndBorder
      showTotalEntries={false}
      entriesPerPage={false}
      canSearch={false}
      table={{ columns: columns, rows: rows }}
    />
  )
}

ReportesInformation.propTypes = {
  registros: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default ReportesInformation
